import { render } from "./SenderUpdate.vue?vue&type=template&id=f5c9f190"
import script from "./SenderUpdate.vue?vue&type=script&lang=js"
export * from "./SenderUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__